(() => {
  const script =
    document.currentScript || document.querySelector('script[src*="article-engagement.js"]');

  if (!script) return;

  const debugEnabled = new URLSearchParams(window.location.search).has('_msp_article_debug');

  if (debugEnabled) {
    window.__mspArticleEngagementReady = 'loading';
    script.dataset.engagementStatus = 'loading';
  }

  const initialize = () => {
    const articleRoot = document.querySelector('.journal-article, article.article, article');
    const articleContent = document.querySelector(
      '[data-article-engagement-content], .journal-article__rte, .article__content, article .rte'
    );

    if (!articleRoot || !articleContent) {
      if (debugEnabled) {
        window.__mspArticleEngagementReady = 'missing-article';
        script.dataset.engagementStatus = 'missing-article';
      }
      return;
    }

    if (debugEnabled) {
      window.__mspArticleEngagementReady = 'ready';
      script.dataset.engagementStatus = 'ready';
    }

  const baseData = {
    article_id: script.dataset.articleId || '',
    article_handle: script.dataset.articleHandle || '',
    article_title: (script.dataset.articleTitle || '').slice(0, 100),
    article_path: window.location.pathname.slice(0, 100),
  };
  const emitted = new Set();

  const recordDebugEvent = (name, data, published) => {
    if (!debugEnabled) return;

    window.__mspArticleEngagementEvents = window.__mspArticleEngagementEvents || [];
    window.__mspArticleEngagementEvents.push({ name, data, published });
    script.dataset.engagementEvents = window.__mspArticleEngagementEvents
      .map((event) => event.name)
      .join(',');
  };

  const publish = (eventName, eventData = {}) => {
    const namespacedEventName = `msp:${eventName}`;
    const payload = { ...baseData, ...eventData };
    const analytics = window.Shopify?.analytics;

    if (!analytics || typeof analytics.publish !== 'function') {
      recordDebugEvent(namespacedEventName, payload, false);
      return false;
    }

    analytics.publish(namespacedEventName, payload);
    recordDebugEvent(namespacedEventName, payload, true);

    return true;
  };

  const publishOnce = (key, eventName, eventData) => {
    if (emitted.has(key)) return;
    if (publish(eventName, eventData) || debugEnabled) emitted.add(key);
  };

  const activeReadThresholds = [30, 60, 120];
  let activeReadMilliseconds = 0;
  let activeSince = null;

  const isActivelyReading = () =>
    document.visibilityState === 'visible' && document.hasFocus();

  const updateActiveReadTime = () => {
    const now = performance.now();

    if (activeSince !== null) {
      activeReadMilliseconds += now - activeSince;
    }

    activeSince = isActivelyReading() ? now : null;

    activeReadThresholds.forEach((seconds) => {
      if (activeReadMilliseconds >= seconds * 1000) {
        publishOnce(`read-${seconds}`, `article_read_${seconds}s`);
      }
    });
  };

  activeSince = isActivelyReading() ? performance.now() : null;
  window.setInterval(updateActiveReadTime, 1000);
  window.addEventListener('focus', updateActiveReadTime);
  window.addEventListener('blur', updateActiveReadTime);
  document.addEventListener('visibilitychange', updateActiveReadTime);
  window.addEventListener('pagehide', updateActiveReadTime);

  const scrollThresholds = [25, 50, 75, 90];
  let scrollFrameRequested = false;

  const measureArticleScroll = () => {
    scrollFrameRequested = false;

    const articleRect = articleContent.getBoundingClientRect();
    const articleTop = articleRect.top + window.scrollY;
    const articleHeight = Math.max(articleContent.scrollHeight, articleRect.height, 1);
    const viewportBottom = window.scrollY + window.innerHeight;
    const percent = Math.max(
      0,
      Math.min(100, Math.floor(((viewportBottom - articleTop) / articleHeight) * 100))
    );

    scrollThresholds.forEach((threshold) => {
      if (percent >= threshold) {
        publishOnce(`scroll-${threshold}`, `article_scroll_${threshold}`);
      }
    });
  };

  const requestScrollMeasurement = () => {
    if (scrollFrameRequested) return;
    scrollFrameRequested = true;
    window.requestAnimationFrame(measureArticleScroll);
  };

  window.addEventListener('scroll', requestScrollMeasurement, { passive: true });
  window.addEventListener('resize', requestScrollMeasurement);
  requestScrollMeasurement();

  articleRoot.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');

    if (!link) return;

    let destination;

    try {
      destination = new URL(link.href, window.location.href);
    } catch (_error) {
      return;
    }

    if (destination.origin !== window.location.origin) return;
    if (!destination.pathname.startsWith('/products/')) return;

    publish('article_product_click', {
      link_url: destination.href.slice(0, 100),
      link_id: destination.pathname.split('/').filter(Boolean).pop()?.slice(0, 100) || '',
      link_text: (link.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 100),
    });
  });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
